import React from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Link as RouterLink } from "react-router-dom"

export function CTASection() {
  const { t } = useTranslation()

  return (
    <section className="bg-primary py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-2xl font-bold text-primary-foreground md:text-3xl lg:text-4xl">
            {t('home.cta.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-primary-foreground/80">
            {t('home.cta.subtitle')}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90" asChild>
              <RouterLink to="/register">
                {t('home.cta.registerNow')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </RouterLink>
            </Button>
            <Button variant="outline" size="lg" className="border-primary-foreground/30 text-primary hover:text-primary bg-background hover:bg-background/90" asChild>
              <RouterLink to="/contact">
                {t('home.cta.contactUs')}
              </RouterLink>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
